import ExpandMore from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { useEffect, useState } from 'react'

export default function SingleExpandAccordionWrapper({
  isExpanded,
  expandOnChange = () => {},
  expandedItemIdentifier,
  accordionSummaryHeading,
  accordionProps,
  children,
}) {
  const [expand, setExpand] = useState(false)

  function handleExpand() {
    if (isExpanded) {
      setExpand((prev) => !prev)
    }
    expandOnChange(expandedItemIdentifier)
  }

  useEffect(() => {
    setExpand(isExpanded)
  }, [isExpanded])
  return (
    <Accordion {...accordionProps} fullWidth expanded={expand} onChange={handleExpand}>
      <AccordionSummary expandIcon={<ExpandMore />}>{accordionSummaryHeading}</AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
